export const FETCH_JOB_SEEKER_SAVED_JOBS = "FETCH_JOB_SEEKER_SAVED_JOBS";
export const FETCH_JOB_ALERT_PREFERENCES = "FETCH_JOB_ALERT_PREFERENCES";

export const JOB_SEEKER_INITIAL_STATE = {
  savedJobs: [],
  jobAlertPreferences: [],
};

export const JOB_ALERT_PREFERENCES_INITIAL_FORM = {
  locations: [],
  industries: [],
  jobKeywords: [],
  isActive: true,
};
